import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BffRedirect from './bff/BffRedirect';
import InvitationPage from './invitation/invitation';
import VoteAreaPage from './checkin_vote/VoteArea';
import TeamPage from './team/TeamPage';
import NotFoundPage from './NotFoundPage';
import PrivacyPage from './PrivacyPage';
import LandingPage from './LandingPage';
import './App.css';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/invitation/:invitationCode" element={<InvitationPage />} />
        <Route path="/music_spot/:areaId" element={<VoteAreaPage />} />
        {/* MusicBFF の招待着地ページは public/bff.html（Sway の index.html を使わせない）。
            通常ここまで届かず、届いたときだけ静的 HTML に逃がす保険。
            /:userNumber/:invitationCode より先に定義する
            (v6 は具体度で勝つが、読み手が誤解しないよう順序でも保証しておく) */}
        <Route path="/bff/*" element={<BffRedirect />} />
        <Route path="/team/:code" element={<TeamPage />} />
        <Route path="/:userNumber/:invitationCode" element={<InvitationPage />} />
        <Route path="/:userNumber" element={<InvitationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
